import { useEffect, useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import { siteRequest, queryString } from "lib/siteCustomerApi";
import { resolveCoursePresentation } from "lib/coursePresentation";
import { formatCourseDisplayPrice } from "lib/speakerPresentation";
import { Pager, Remote } from "./Shared";

function usePartnerRead(path, tick, session) {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    const ctrl = new AbortController(); setState({ loading: true });
    siteRequest(path, { signal: ctrl.signal }).then(r => { if (!ctrl.signal.aborted) setState({ data: r.data }); })
      .catch(error => { if (!ctrl.signal.aborted) setState({ error }); });
    return () => ctrl.abort();
  }, [path, tick, session]);
  return state;
}
export function PartnerNavigation({ profile }) {
  const [state, setState] = useState({}), [tick, setTick] = useState(0);
  useEffect(() => {
    const ctrl = new AbortController(); setState({});
    (async () => {
      let after = null;
      do {
        const r = await siteRequest("/customer/partner-memberships?" + queryString({ limit: 100, after }), { signal: ctrl.signal });
        if (ctrl.signal.aborted) return;
        if (!Array.isArray(r.data?.items)) throw Error("Partner access could not be verified.");
        if (r.data.items.length) { setState({ eligible: true }); return; }
        after = r.data.next;
      } while (after);
      setState({ eligible: false });
    })().catch(error => { if (!ctrl.signal.aborted) setState({ error }); });
    return () => ctrl.abort();
  }, [profile, tick]);
  return state.eligible ? <NavLink to="/customer/access/partners">Partner access</NavLink> : state.error ?
    <span role="alert">Partner access is unavailable. <button onClick={() => setTick(v => v + 1)}>Retry partner access</button></span> : null;
}
export default function PartnerPortal({ profile }) {
  const { partnerId } = useParams();
  return <PartnerView key={partnerId || "selector"} id={partnerId} profile={profile} />;
}
function PartnerView({ id, profile }) {
  const [pages, setPages] = useState([null]), [tick, setTick] = useState(0);
  const path = (id ? `/customer/partners/${id}/courses` : "/customer/partner-memberships") + "?" + queryString({ limit: 25, after: pages.at(-1) });
  const state = usePartnerRead(path, tick, profile);
  const refresh = () => { setPages([null]); setTick(v => v + 1); };
  return <>
    <p className="ca-eyebrow">Read-only partner access</p><h1>{id ? "Partner catalog" : "Choose partner"}</h1>
    <div className="ca-actions"><Link to={id ? "/customer/access/partners" : "/customer/access"}>{id ? "← Choose partner" : "← Back to account"}</Link>
      <button disabled={state.loading} onClick={refresh}>Refresh partner access</button></div>
    <Remote state={state}>{state.data && <>
      {id && <section className="ca-panel"><h2>{state.data.partner.name}</h2><p>{state.data.partner.programType === "affiliate" ? "Affiliate" : "Reseller"} · Read-only portal enabled</p>
        <p>Published course information only. This portal does not grant course or file access.</p><p className="ca-notice">Earnings and sales codes are not configured.</p></section>}
      <div className="ca-list">
        {!state.data.items.length && <p className="ca-panel">{id ? "No published courses on this page." : "No eligible partner memberships on this page."}</p>}
        {state.data.items.map(row => {
          if (!id) return <article className="ca-panel" key={row.id}><h2>{row.name}</h2><p>{row.programType === "affiliate" ? "Affiliate" : "Reseller"}</p><Link to={`/customer/access/partners/${row.id}`}>Open partner catalog</Link></article>;
          const theme = resolveCoursePresentation(row);
          return <article className="ca-panel" key={row.id} data-course-theme={theme.key} style={{ borderTopColor: theme.accent }}><p className="ca-eyebrow">{theme.label}</p>
            <h2>{row.title}</h2><p>{row.description}</p><p>{formatCourseDisplayPrice(row)}</p><Link to={`/webinars/${row.slug}`}>View public course details</Link></article>;
        })}
      </div><Pager next={state.data.next} pages={pages} setPages={setPages} />
    </>}</Remote>
  </>;
}
